import { useTranslation } from 'react-i18next';
import { Mark } from '../components/Layout';
import { LanguageSwitch } from '../components/ui';
import { useTenant } from '../lib/tenant';

export function SchoolUnavailable({ reason }: { reason: 'not_found' | 'suspended' }) {
  const { t, i18n } = useTranslation();
  const tenant = useTenant();
  const school = tenant.school ? (i18n.language === 'ar' && tenant.school.nameAr) || tenant.school.name : '';
  return (
    <div className="login">
      <div className="login-lang">
        <LanguageSwitch />
      </div>
      <section className="login-card">
        <div className="login-brand">
          <Mark />
          <h1>{tenant.platformName}</h1>
        </div>
        <h2>{reason === 'suspended' ? t('unavailable.suspendedTitle', { school }) : t('unavailable.notFoundTitle')}</h2>
        <p className="muted">{reason === 'suspended' ? t('unavailable.suspendedText', { name: tenant.platformName }) : t('unavailable.notFoundText')}</p>
        <a className="btn btn-block" href={tenant.platformUrl}>
          {t('unavailable.home', { name: tenant.platformName })}
        </a>
      </section>
    </div>
  );
}
